import { Component } from '@angular/core';

@Component({
  selector: 'app-our-values',
  templateUrl: './our-values.component.html',
  styleUrl: './our-values.component.scss'
})
export class OurValuesComponent {

  values = [ 
    {
      title: 'Compromiso',
      description: 'Cada proyecto es una promesa cumplida.'
    },
    {
      title: 'Calidad y seguridad',
      description: 'Construimos con rigor técnico y respeto por las personas.'
    },
    {
      title: 'Cercanía',
      description: 'Nos involucramos con nuestros clientes como socios, no como proveedores.'
    },
    {
      title: 'Innovación',
      description: 'Buscamos siempre mejores formas de construir, optimizar y servir'
    },
    {
      title: 'Transparencia',
      description: 'Actuamos con honestidad y claridad, porque la confianza es la base de cada relación duradera.'
    },
  ]

  trackElement(index: number): number {
    return index;
  }

}
